{
  "nav": {
    "home": "Home",
    "about": "About"
  },
  "topbar": {
    "toggleNavigation": "Toggle navigation",
    "search": "Search",
    "openAiChat": "Open AI chat",
    "switchToEnglish": "Switch to English",
    "switchToSpanish": "Switch to Spanish"
  },
  "aiChat": {
    "label": "AI chat",
    "comingSoon": "AI chat coming soon"
  },
  "home": {
    "heading": "future-client",
    "paragraph1": "future-client is the new home for Presence Learning's provider and school experience - a ground-up rebuild designed to replace edu-clients screen by screen rather than all at once.",
    "paragraph2": "Every piece you see here, from the navigation to the theme, is built on our shared component library so the app looks and behaves consistently with the rest of the Presence platform from day one.",
    "paragraph3": "This is still early - most of what will eventually live here hasn't been built yet. Check back as more of the experience moves over."
  },
  "about": {
    "heading": "About",
    "paragraph1": "This project exists to give Presence Learning's engineering team a modern, well-tested foundation to build on, instead of continuing to extend an aging codebase that's grown harder to change safely over time.",
    "paragraph2": "We're prioritizing accessibility, performance, and observability from the very first commit, so the quality bar for every new screen is set before the screen itself exists.",
    "paragraph3": "The migration will happen incrementally, one portal and one workflow at a time, so users experience a steady stream of improvements rather than one large, risky cutover."
  }
}
